import { computed, unref, type MaybeRef } from 'vue'

export interface CalendarCell {
  value: Date
  label: string
}

export function useCalendarRows(calendarPosition: MaybeRef<Date | null>) {
  const start = computed(() => {
    const calendarPositionVal = unref(calendarPosition) ?? new Date()
    const start = new Date(calendarPositionVal)
    start.setDate(1) // First dat of current month
    start.setDate(start.getDate() - start.getDay())
    return start
  })

  const end = computed(() => {
    const calendarPositionVal = unref(calendarPosition) ?? new Date()
    const end = new Date(calendarPositionVal)
    end.setMonth(end.getMonth() + 1, -1) // Last day of current month
    end.setDate(end.getDate() + 6 - end.getDay())
    return end
  })

  const calendarRows = computed(() => {
    const startVal = new Date(start.value)
    const endVal = new Date(end.value)

    const msInDay = 1000 * 60 * 60 * 24

    const days = Math.floor((endVal.getTime() - startVal.getTime()) / msInDay) + 1

    if (days === 28) startVal.setDate(startVal.getDate() - 7)
    if (days <= 35) endVal.setDate(endVal.getDate() + 7)

    const rows: CalendarCell[][] = [[]]

    for (let date = startVal; date <= endVal; ) {
      let lastRow = rows.at(-1)!
      if (lastRow.length === 7) {
        rows.push([])
        lastRow = rows.at(-1)!
      }

      lastRow.push({ value: date, label: date.getDate().toString() })

      date = new Date(date)
      date.setDate(date.getDate() + 1)
    }

    return rows
  })

  return calendarRows
}
